import React from 'react';
import { Card, Container } from "@material-ui/core";
import { BrightnessAutoOutlined, BuildOutlined, HourglassEmptyOutlined } from "@material-ui/icons";

class aboutContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      skills : ["Vue", "React", "Angular", "ES6 Javascript", "Node.js","Material", "Bootstrap", "Ajax", "Axios", "MongoDb", "Mysql", "Sql", "Php", "Unity", "Postgres", "Flask", "Flask-sqlAlchemy", "Python", "Bcrypt", "Jason Web Token", "Cookie parser", "Apache", "Linux", "Mongoose", "Webpack", "Sass", "Less", ]
    }

  }
  render() {
    return (
      <section className="container-about">
             <Container className="description">
              <h4 className="about-title"><BrightnessAutoOutlined></BrightnessAutoOutlined> Brief Intro</h4>
               <p>A fullstack developer with a passion for responsive U/I, Clean Code, and experimenting with numerous technologies to create awesome, functional application experiences.</p>
               <p>I create, edit, rethink design and development of all projects while keeping in mind security, performance and usability in mind.</p>
             </Container>

          <h3 className="skills-title">Different Skills <BuildOutlined></BuildOutlined> , <HourglassEmptyOutlined></HourglassEmptyOutlined> Technologies that keep Racking up...</h3>
          <Container className="row-about">
              {
                this.state.skills.map((skill, i) => (
                    <div key={i}>
                      <Card className="skill" >
                        {skill}
                      </Card>
                  </div>
                ))
              }
            </Container>
      </section>
      )
  }
};

export default aboutContainer;